import { Box, Skeleton, Paper } from "@mui/material";

interface RecordListSkeletonComponentProps {
    columnsCount?: number;
    rowsCount?: number;
    rowHeight?: number;
}

const RecordListSkeletonComponent = ({
    columnsCount = 5,
    rowsCount = 8,
    rowHeight = 40
}: RecordListSkeletonComponentProps) => {
    return (
        <Paper elevation={1}>
            <Box display="flex" flexDirection="column">
                {/* Header */}
                <Box
                    display="grid"
                    gridTemplateColumns={`repeat(${columnsCount}, 1fr)`}
                    gap={1}
                    padding={1}
                >
                    {Array.from({ length: columnsCount }).map((_, i) => (
                        <Skeleton
                            key={`header_${i}`}
                            variant="text"
                            height={24}
                            width={`${Math.floor(Math.random() * 30) + 40}%`}
                        />
                    ))}
                </Box>

                {/* Rows */}
                {Array.from({ length: rowsCount }).map((_, rowIndex) => (
                    <Box
                        key={`row_${rowIndex}`}
                        display="grid"
                        gridTemplateColumns={`repeat(${columnsCount}, 1fr)`}
                        gap={1}
                        padding={1}
                    >
                        {Array.from({ length: columnsCount }).map((_, colIndex) => (
                            <Skeleton
                                key={`cell_${rowIndex}_${colIndex}`}
                                variant="rounded"
                                height={rowHeight}
                            />
                        ))}
                    </Box>
                ))}
            </Box>
        </Paper>
    );
};

export default RecordListSkeletonComponent;